export default __webpack_public_path__ + "static/media/1.8ed90c90.png";